import { getJson } from "../../auth/utils/getJson.js";

/** GET /api/dataQuality?operator=...&unit=...&meter=...&fromDate=...&toDate=... */
export function fetchDataQuality(
  { operator, unit, meter, fromDate, toDate },
  signal
) {
  const qs = new URLSearchParams();
  if (operator) qs.set("operator", operator);
  if (unit != null) qs.set("unit", String(unit));
  if (meter != null) qs.set("meter", String(meter));
  if (fromDate) qs.set("fromDate", fromDate);
  if (toDate) qs.set("toDate", toDate);

  return getJson(`/api/dataQuality?${qs.toString()}`, { signal });
}

/** GET /api/dataQuality/filter-directory */
export function fetchFilterDirectory(signal) {
  return getJson("/api/dataQuality/filter-directory", { signal });
}
